<template>
    <div class="Dashboard">
        <div class="d-flex align-center justify-space-between header-page">
            <div class="page-title">{{ $f.tc('nav.user.dashboard') }}</div>
            <v-layout align-center justify-end>
                <div style="width: 180px">
                    <v-select
                        color="#0052CC"
                        v-model="callType"
                        :items="callTypeList"
                        :label="$f.tc('type')"
                        class="select-custom"
                        item-text="name"
                        item-value="value"
                        @input="updateCallType"
                    ></v-select>
                </div>
                <div style="width: 180px">
                    <v-select
                        :disabled="timeRange!=='today'"
                        color="#0052CC"
                        :label="$t('refresh') | capitalize"
                        v-model="autoRefreshInterval"
                        :items="autoRefreshIntervalList"
                        class="select-custom"
                    ></v-select>
                </div>
                <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"></TimeRangePicker>
            </v-layout>
        </div>
        <v-container fluid class="fci-scrollbar"
                     style="padding: 15px 20px !important; height: calc(100vh - 123px); overflow-y: auto">
            <div
                style="padding: 80px 0; border: 1px solid #D9D9D9; background: #fff; border-radius: 5px;"
                v-if="(!overviewCharts.length) && (!callDurationChart.total) && (!callByTimeChart.total)"
            >
                <div
                    style="font-size: 14px !important; display: flex; flex-direction: column; align-items: center; justify-content: center">
                    <div style="margin-bottom: 12px">{{ $f.tc('noDataAvailable') }}</div>
                    <div class="btn-custom" @click="createDashboard" v-if="isEditable">
                        {{ $f.tc('createCampaign') }}
                    </div>
                </div>
            </div>
            <v-container fluid grid-list-lg class="pl-0 pr-0 pt-0" v-else>
                <!--OUTBOUND-->
                <v-layout row wrap align-space-around fill-height class="dashboard-dough-nut-charts"
                          v-if="callType==='outbound' && overviewCharts && overviewCharts.length">
                    <v-flex xs12 md4 v-for="(chart, index) in overviewCharts" :key="index">
                        <DoughNutChartCustom
                            :data="chart"
                            chart-title="title empty"
                            additional-header="subTitle empty"
                            :show-table="true"
                            :unit="index===0?'customers':'calls'"
                        ></DoughNutChartCustom>
                    </v-flex>
                </v-layout>
                <!--INBOUND-->
                <v-layout row wrap v-if="callType==='inbound' && overviewCharts && overviewCharts.length">
                    <!--Chart bot response time-->
                    <v-flex xs12 md8 style="position: relative">
                        <div class="card-chart">
                            <div style="padding: 10px 10px 6px 10px">
                                <div class="title-chart">{{ $f.tc('botResponseTime') }}</div>
                            </div>
                            <div v-if="botResponseTimeChart.total > 0" style="padding-right: 10px; position: relative">
                                <CampaignStackBarChart
                                    :data="botResponseTimeChart"
                                    :height="100"
                                    :y-axis-ticks="true"
                                    ref="StackBarChartBotResponseTime"
                                ></CampaignStackBarChart>
                            </div>
                            <div v-else style="text-align: center; margin-top: 20px">
                                <img src="/img/bar-chart-2.png" alt="bar-chart"
                                     style="height: 180px; margin-bottom: 16px">
                                <div style="margin-bottom: 20px; font-size: 14px; color: #96ADD0">
                                    {{ $f.tc('noDataAvailable') }}
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <!--Chart total call-->
                    <v-flex xs12 md4>
                        <div v-if="overviewCharts[0]">
                            <DoughNutChartCustom
                                :data="overviewCharts[0] ? overviewCharts[0] : []"
                                :show-table="true"
                                chart-title="title empty"
                                additional-header="subTitle empty"
                                class="dough-nut-chart-wrap-custom"
                                :unit="'calls'"
                                ref="chart1"/>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-space-around fill-height class="dashboard-dough-nut-charts"
                          v-if="!overviewCharts.length">
                    <v-flex xs12>
                        <LoadingBox :font-size="15" :size-loading="30"></LoadingBox>
                    </v-flex>
                </v-layout>
                <v-layout row wrap style="margin-top: 8px">
                    <v-flex xs12 md6>
                        <div class="card-chart">
                            <v-layout align-center justify-space-between style="padding: 20px 20px 6px 20px">
                                <div class="title-chart">{{ $f.tc('numberOfCallsByTime') }}</div>
                                <div style="width: 120px">
                                    <v-select
                                        hide-details
                                        color="#0052CC"
                                        v-model="interval"
                                        :items="listOptionTimes"
                                        item-text="name"
                                        item-value="key"
                                        class="select-custom"
                                        @input="updateInterval"
                                        style="margin-right: 0 !important;"
                                    ></v-select>
                                </div>
                            </v-layout>
                            <div v-if="callByTimeChart.total > 0" style="padding-right: 10px">
                                <stack-bar-chart
                                    :data="callByTimeChart"
                                    :title-left="`${this.$f.tc('numberOfCalls')} (${this.$t('unit')}: 1000)`"
                                    :y-axis-ticks="true"
                                    ref="StackBarChartCallByTime"
                                ></stack-bar-chart>
                            </div>
                            <div v-else style="text-align: center; margin-top: 20px">
                                <img src="/img/bar-chart-1.png" alt="bar-chart"
                                     style="height: 280px; margin-bottom: 16px">
                                <div style="margin-bottom: 20px; font-size: 14px ; color: #96ADD0">
                                    {{ $f.tc('noDataAvailable') }}
                                </div>
                            </div>
                        </div>
                    </v-flex>
                    <v-flex xs12 md6 style="position: relative">
                        <div class="card-chart">
                            <div style="padding: 10px 10px 6px 10px">
                                <div class="title-chart">{{ $f.tc('callDuration') }}</div>
                            </div>
                            <div v-if="callDurationChart.total > 0" style="padding-right: 10px">
                                <stack-bar-chart
                                    :data="callDurationChart"
                                    :title-left="`${this.$f.tc('numberOfCalls')} (${this.$t('unit')}: 1000)`"
                                    :y-axis-ticks="true"
                                    ref="StackBarChartCallDuration"
                                ></stack-bar-chart>
                                <div class="btn-icon btn-info-chart">
                                    <v-icon color="#96ADD0">mdi-information</v-icon>
                                </div>
                                <div class="info-chart">
                                    <table class="additional-data">
                                        <tbody>
                                        <tr v-for="(item, index) in avgDurationPerCall" :key="index">
                                            <td>{{ $f.tc(`${index}`) }}</td>
                                            <td><b>{{ item }}</b></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else style="text-align: center; margin-top: 20px">
                                <img src="/img/bar-chart-2.png" alt="bar-chart"
                                     style="height: 280px; margin-bottom: 16px">
                                <div style="margin-bottom: 20px; font-size: 14px; color: #96ADD0">
                                    {{ $f.tc('noDataAvailable') }}
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <div v-if="overviewData && overviewData.data && overviewData.data.length > 0" class="mb-6" style="width: 250px;float: right">
                    <SearchCampaign
                        :keyword="filter.search"
                        @input="searchNow($event)"
                        @campaign-selected="viewCampaignSearch($event)"
                        :show-list="false"
                        class="search-custom">
                    </SearchCampaign>
                </div>
                <SimpleDataTable
                    v-if="overviewData && overviewData.data && overviewData.data.length > 0"
                    :headers="headers"
                    :items="filter.search !== '' ? searchList: overviewData.data"
                    :pagination.sync="pagination"
                    @row-click="viewCampaign($event)"
                    @item-per-page-change="updateRowPerPage"
                    class="overview-table"
                ></SimpleDataTable>
            </v-container>
        </v-container>
    </div>
</template>
<script>
import DoughNutChartCustom from "@/components/chart/DoughNutChartCustom";
import DashboardService from '@/services/dashboard.service'
import TimeRangePicker from "@/modules/fptai/components/TimeRangePicker";
import AutoRefreshMixin from "@/modules/fptai/mixins/AutoRefreshMixin";
import StackBarChart from "@/components/chart/StackBarChart";
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import ScenarioService from "@/services/scenario.service";
import CampaignStackBarChart from "@/views/Campaign/CampaignStackBarChart";
import lodash from "lodash";
import $const from "@/utils/const";
import {thisGroup} from "@/modules/fptai/components/TimeRangePickerQuickOptions";
import SearchCampaign from "@/views/Campaign/Form/SearchCampaign.vue";
import LoadingBox from "@/components/LoadingBox.vue";

const queriesAccept = ['call_type', 'time_range', 'interval']
const defaultFilter = {
    timeRange: 'today',
    callType: 'outbound'
}
const showTimeRangeTypes = $const.ShowTimeRangeTypes

export default {
    name: 'Dashboard',
    components: {
        LoadingBox,
        SearchCampaign,
        SimpleDataTable,
        StackBarChart,
        DoughNutChartCustom,
        TimeRangePicker,
        CampaignStackBarChart,
    },
    mixins: [AutoRefreshMixin],
    data() {
        return {
            callType: this.$utils.cloneObject(defaultFilter.callType),
            overviewData: null,
            overviewCharts: [],
            callDurationChart: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0,
                maxCountChart: 0
            },
            callByTimeChart: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0,
                maxCountChart: 0
            },
            botResponseTimeChart: {
                datasets: [],
                labels: [],
                tooltip: [],
                total: 0,
                maxCountChart: 0
            },
            timeRange: this.$utils.cloneObject(defaultFilter.timeRange),
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 10,
                sortBy: '',
                totalItems: 0
            },
            avgDurationPerCall: {
                totalCalls: '',
                totalDuration: '',
                avg: ''
            },
            formatDateTime: '',
            interval: '',
            listOptionTimes: [],
            filter: {
                status: '',
                direction: '',
                search: ''
            },
            searchList: [],
        }
    },
    computed: {
        isEditable: () => ScenarioService.isEditable(),
        callTypeList() {
            return [
                {
                    value: 'outbound',
                    name: this.$f.tc('outbound')
                },
                {
                    value: 'inbound',
                    name: this.$f.tc('inbound')
                }
            ]
        },
        headers() {
            return this.overviewData.headers.map(header => {
                switch (header.value) {
                    case 'status':
                    case 'record_url':
                        return {
                            ...header,
                            id: header.value,
                            align: 'center',
                            class: 'text-center',
                            type: 'custom'
                        }
                    case 'pickup_date':
                    case 'pickup_time':
                    case 'start_time':
                    case 'end_time':
                        return {
                            ...header,
                            id: header.value,
                            align: 'center',
                            class: 'text-center',
                            $value: item => this.$filters.formatDateTime(item[header.value])
                        }
                    case 'start_date':
                    case 'end_date':
                        return {
                            ...header,
                            id: header.value,
                            align: 'center',
                            class: 'text-center',
                            $value: item => this.$filters.formatDate(item[header.value])
                        }
                    case 'duration':
                    case 'avg_call_time':
                    case 'call_transfer_duration':
                        return {
                            ...header,
                            id: header.value,
                            align: 'center',
                            class: 'text-center',
                            $value: item => item[header.value] === 'N/A' || item[header.value] === 0 ? 'N/A' : this.$filters.toHMS(item[header.value])
                        }
                    case 'total_call_time':
                        return {
                            ...header,
                            id: header.value,
                            align: 'center',
                            class: 'text-center',
                            $value: item => item[header.value] === 0 ? '00:00:00' : this.$filters.toHMS(item[header.value])
                        }
                    case 'title':
                        return header
                    default:
                        return {
                            ...header,
                            align: 'center',
                            class: 'text-center',
                        }
                }
            })
        },
        listFilter() {
            return [
                {
                    name: '1 ' + this.$f.tc('minute'),
                    value: 60000,
                    key: '1m',
                },
                {
                    name: '3 ' + this.$f.tc('minute'),
                    value: 3 * 60000,
                    key: '3m',
                },
                {
                    name: '5 ' + this.$f.tc('minute'),
                    value: 5 * 60000,
                    key: '5m',
                },
                {
                    name: '10 ' + this.$f.tc('minute'),
                    value: 10 * 60000,
                    key: '10m',
                },
                {
                    name: '30 ' + this.$f.tc('minute'),
                    value: 30 * 60000,
                    key: '30m',
                },
                {
                    name: '1 ' + this.$f.tc('hour'),
                    value: 60 * 60000,
                    key: '1h',
                },
                {
                    name: '2 ' + this.$f.tc('hour'),
                    value: 2 * 60 * 60000,
                    key: '2h',
                },
                {
                    name: '4 ' + this.$f.tc('hour'),
                    value: 4 * 60 * 60000,
                    key: '4h',
                },
                {
                    name: '8 ' + this.$f.tc('hour'),
                    value: 8 * 60 * 60000,
                    key: '8h',
                },
                {
                    name: '1 ' + this.$f.tc('day'),
                    value: 24 * 60 * 60000,
                    key: '1d',
                },
                {
                    name: '2 ' + this.$f.tc('day'),
                    value: 2 * 24 * 60 * 60000,
                    key: '2d',
                },
                {
                    name: '5 ' + this.$f.tc('day'),
                    value: 5 * 24 * 60 * 60000,
                    key: '5d',
                },
                {
                    name: '10 ' + this.$f.tc('day'),
                    value: 10 * 24 * 60 * 60000,
                    key: '10d',
                },
                {
                    name: '1 ' + this.$f.tc('month'),
                    value: 30 * 24 * 60 * 60000,
                    key: '1M',
                },
            ]
        }
    },
    mounted() {
        this.beforeRefresh()
    },
    methods: {
        beforeRefresh() {
            let query = this.$utils.cloneObject(this.$route.query)

            // validate size_most_phone
            let callType = query['call_type'] ? query['call_type'] : null
            if (callType && this.callTypeList.find(i => i.value === callType)) {
                this.callType = callType
            } else {
                delete query['call_type']
            }

            if (!query['time_range'] || (query['time_range'] && query['time_range'] === defaultFilter.timeRange)) {
                this.updateDataCharts(query.interval)
            } else {
                this.updateTimeRangeFilter()
            }

            this.$router.replace({
                query: query
            })
        },
        updateTimeRangeFilter() {
            let query = this.$utils.cloneObject(this.$route.query)
            // validate time_range
            if (query['time_range']) {
                if (thisGroup.find(i => i.value === query['time_range'])) { // case quick option
                    this.timeRange = query['time_range']
                } else { // case custom
                    let timeRangeSplit = query['time_range'].split("to")
                    let from = parseInt(timeRangeSplit[0]) || null
                    let to = parseInt(timeRangeSplit[1]) || null
                    if (from && to && to > from) {
                        let format = 'YYYY-MM-DD HH:mm'
                        let fromTime = this.$utils.convertTimestampToStringFormat(from, format)
                        let toTime = this.$utils.convertTimestampToStringFormat(to, format)
                        this.$refs.TimeRangePicker.updateTypeShow(showTimeRangeTypes.CUSTOM)
                        this.$refs.TimeRangePicker.updateFromToCustom(`${fromTime} ➜ ${toTime}`)
                        this.timeRange = `${fromTime} ➜ ${toTime}`
                    } else {
                        delete query['time_range']
                    }
                }
            } else {
                delete query['time_range']
            }
        },
        updateDataCharts(key) {
            this.listOptionTimes = this.updateOptionTimes()
            if (key && this.listOptionTimes.find(i => i.key === key)) {
                this.interval = key
            } else {
                this.interval = this.listOptionTimes[0].key
                let query = this.$utils.cloneObject(this.$route.query)
                delete query.interval
                this.$router.replace({
                    query: query
                })
            }
            this.updateInterval(false)
            this.refresh()
        },
        updateOptionTimes() {
            let optionTimes = []
            let timeRange = this.$refs.TimeRangePicker.getTimeRangeInDjango()
            let timeTo
            if (Date.parse(timeRange.to) > Date.now()) {
                timeTo = Date.now()
            } else timeTo = Date.parse(timeRange.to)
            let duration_filter = timeTo - Date.parse(timeRange.from)
            // check timeRange trong khoảng cho phép
            for (let f = 0; f < this.listFilter.length; f++) {
                if (Math.floor(duration_filter / 30) < parseInt(this.listFilter[f].value) && parseInt(this.listFilter[f].value) < Math.floor(duration_filter / 5)) {
                    optionTimes.push(this.listFilter[f])
                }
            }
            if (Math.floor(duration_filter / 30) <= parseInt(this.listFilter[0].value)) {
                optionTimes.push(this.listFilter[0])
            }
            if (Math.floor(duration_filter / 5) >= parseInt(this.listFilter.slice(-1)[0].value)) {
                optionTimes.push(this.listFilter.slice(-1)[0])
            }
            return optionTimes
        },
        updateInterval(isLoadData) {
            this.updateQueryRoute('interval', this.interval, this.listOptionTimes[0].key)
            if (isLoadData) {
                this.loadCallByTimeChartData()
            }
            this.mapIntervalFormat()
        },
        refresh() {
            this.mapIntervalFormat()
            this.getDataChart()
        },
        mapIntervalFormat() {
            let lastChar = this.interval.substring(this.interval.length - 1)
            switch (lastChar) {
                case 'M':
                    this.formatDateTime = 'MM-YYYY'
                    break
                case 'd':
                    this.formatDateTime = 'DD-MM-YYYY'
                    break
                default:
                    this.formatDateTime = 'HH:mm DD-MM-YYYY'
                    break
            }
        },
        getDataChart() {
            Promise.all([
                this.loadOverviewChart(),
                this.loadCallDurationChartData(),
                this.loadCallByTimeChartData(),
                this.loadTableData()
            ])
                .then(() => {
                        if (this.$refs.StackBarChartCallByTime) {
                            this.$refs.StackBarChartCallByTime.render()
                        }
                        if (this.$refs.StackBarChartCallDuration) {
                            this.$refs.StackBarChartCallDuration.render()
                        }
                    }
                )
                .catch(this.stopInterval)
        },
        loadOverviewChart() {
            this.overviewCharts = []
            return new Promise((resolve, reject) => {
                let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
                DashboardService.getOverviewChart(
                    {
                        from: timeStamp.from,
                        to: timeStamp.to,
                        type: this.callType
                    }
                ).then(result => {
                    this.overviewCharts = result.data['data']
                    if (this.callType === 'inbound') {
                        this.loadBotResponseChart(this.overviewCharts[1])
                    }
                    resolve()
                }, error => {
                    this.$appService.hideLoading()
                    reject(error)
                })
            })
        },
        loadCallDurationChartData() {
            return new Promise((resolve, reject) => {
                let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
                DashboardService.getNumberCallsByCallDuration(
                    {
                        from: timeStamp.from,
                        to: timeStamp.to,
                        type: this.callType
                    }
                ).then(result => {
                    if (result.data) {
                        let listDataDropByCustomer = []
                        let listDataDropByBOT = []
                        let listDataCallTransfer = []
                        let listTooltip = []
                        this.callDurationChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: result.data['total_calls'],
                            maxCountChart: result.data['max_count_chart']
                        }
                        this.avgDurationPerCall = {
                            totalCalls: result.data['total_calls'],
                            totalDuration: this.$filters.toHMS(result.data['talk_time_calls']),
                            avg: this.$filters.toHMS((Number(result.data['talk_time_calls']) / Number(result.data['total_calls'])).toFixed(3))
                        }
                        result.data.data_chart.forEach(item => {
                            listTooltip.push(
                                [
                                    {
                                        name: 'Durations',
                                        value: item['from_to']
                                    },
                                    {
                                        name: 'Total calls',
                                        value: item['count_call']
                                    },
                                    {
                                        name: 'Drop by bot',
                                        value: item['drop_by_bot']
                                    },
                                    {
                                        name: 'Drop by customer',
                                        value: item['drop_by_customer']
                                    },
                                    {
                                        name: 'Call transfer',
                                        value: item['call_transfer']
                                    }
                                ]
                            )
                            listDataDropByCustomer.push(item['drop_by_customer'])
                            listDataDropByBOT.push(item['drop_by_bot'])
                            listDataCallTransfer.push(item['call_transfer'])
                            this.callDurationChart.labels.push(item['from_to'])
                        })
                        this.callDurationChart.tooltip = listTooltip
                        this.callDurationChart.datasets = [
                            {
                                label: "Drop by customer",
                                data: listDataDropByCustomer,
                                backgroundColor: '#1A68FF',
                            },
                            {
                                label: 'Drop by BOT',
                                data: listDataDropByBOT,
                                backgroundColor: '#FFAC36',
                            },
                            {
                                label: 'Call Transfer',
                                data: listDataCallTransfer,
                                backgroundColor: '#376240de'
                            }
                        ]
                    } else {
                        this.callDurationChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: 0,
                            maxCountChart: 0
                        }
                    }
                    resolve()
                }, error => {
                    this.$appService.hideLoading()
                    reject(error)
                })
            })
        },
        loadCallByTimeChartData() {
            if (!this.interval) {
                return
            }
            return new Promise((resolve, reject) => {
                let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
                DashboardService.getNumberCallsByTime(
                    {
                        from: timeStamp.from,
                        to: timeStamp.to,
                        type: this.callType
                    },
                    this.interval
                ).then(result => {
                    if (result.data) {
                        let listDataConnected = []
                        let listDataUnconnected = []
                        let listDataInBlackList = []
                        let listTooltip = []
                        this.callByTimeChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: result.data['total_calls'],
                            maxCountChart: result.data['max_count_chart']
                        }
                        result.data.data_chart.forEach((item, index) => {
                            listDataConnected.push(item['connected']['total_calls'])
                            listDataUnconnected.push(item['unconnected']['total_calls'])
                            listDataInBlackList.push(item['in_black_list']['total_calls'])
                            this.callByTimeChart.labels.push(this.$utils.convertTimestampToStringFormat(item['date_time'], this.formatDateTime))
                            let endTime
                            if (index + 1 >= result.data.data_chart.length) {
                                switch (timeStamp.to < Date.now()) {
                                    case true:
                                        endTime = timeStamp.to / 1000
                                        break
                                    case false:
                                        endTime = Date.now() / 1000
                                        break
                                }
                            } else {
                                endTime = result.data.data_chart[index + 1]['date_time']
                            }
                            listTooltip.push(
                                [
                                    {
                                        name: 'Start time',
                                        value: this.$utils.convertTimestampToStringFormat(item['date_time'], this.formatDateTime)
                                    },
                                    {
                                        name: 'End time',
                                        value: this.$utils.convertTimestampToStringFormat(endTime, this.formatDateTime)
                                    },
                                    {
                                        name: 'Total calls',
                                        value: `${item['total_calls']} (${item['total_calls'] / item['total_calls'] * 100}%)`
                                    },
                                    {
                                        name: 'Connected',
                                        value: `${item['connected']['total_calls']} (${Math.round(item['connected']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    },
                                    {
                                        name: 'In Black List',
                                        value: `${item['in_black_list']['total_calls']} (${Math.round(item['in_black_list']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    },
                                    {
                                        name: 'Unconnected',
                                        value: `${item['unconnected']['total_calls']} (${Math.round(item['unconnected']['total_calls'] / item['total_calls'] * 10000) / 100}%)`
                                    }
                                ]
                            )
                        })
                        this.callByTimeChart.tooltip = listTooltip
                        this.callByTimeChart.datasets = [
                            {
                                label: "Connected",
                                data: listDataConnected,
                                backgroundColor: '#2BC685',
                                data_chart: result.data.data_chart,
                            },
                            {
                                label: 'Unconnected',
                                data: listDataUnconnected,
                                backgroundColor: '#FA7402',
                                data_chart: result.data.data_chart,
                            },
                            {
                                label: 'In Black List',
                                data: listDataInBlackList,
                                backgroundColor: '#696C80',
                                data_chart: result.data.data_chart,
                            }
                        ]
                    } else {
                        this.callByTimeChart = {
                            labels: [],
                            datasets: [],
                            tooltip: [],
                            total: 0,
                            maxCountChart: 0
                        }
                    }
                    resolve()
                }, error => {
                    this.$appService.hideLoading()
                    reject(error)
                })
            })
        },
        loadTableData() {
            return new Promise((resolve, reject) => {
                DashboardService.getOverviewData(
                    this.pagination,
                    this.$refs.TimeRangePicker.getTimestamp(),
                    this.callType
                ).then(result => {
                    this.overviewData = result.data
                    this.pagination.totalItems = result.data.count
                    resolve()
                }, error => {
                    reject(error)
                }).finally(this.$appService.hideLoading)
            })
        },
        loadBotResponseChart(dataChart) {
            if (dataChart) {
                let listDataCall = []
                let listTooltip = []
                this.botResponseTimeChart = {
                    labels: [],
                    datasets: [],
                    tooltip: [],
                    total: dataChart['total_calls'],
                    maxCountChart: dataChart['max_count_chart']
                }
                dataChart.data_chart.forEach(item => {
                    listTooltip.push(
                        [
                            {
                                name: 'Response Time',
                                value: item['response_time']
                            },
                            {
                                name: 'Call',
                                value: item['call']
                            }
                        ]
                    )
                    listDataCall.push(item['call'])
                    this.botResponseTimeChart.labels.push(item['response_time'])
                })
                this.botResponseTimeChart.tooltip = listTooltip
                this.botResponseTimeChart.datasets = [
                    {
                        label: "Call",
                        data: listDataCall,
                        backgroundColor: '#1A68FF',
                    }
                ]
            } else {
                this.botResponseTimeChart = {
                    labels: [],
                    datasets: [],
                    tooltip: [],
                    total: 0,
                    maxCountChart: 0
                }
            }
        },
        updateCallType(newVal) {
            this.updateQueryRoute('call_type', newVal, defaultFilter.callType)
            this.updateDataCharts(this.interval)
        },
        viewCampaign(campaign) {
            this.$router.push('/campaign/' + campaign.campaign_id)
        },
        updateRowPerPage(value) {
            this.pagination.rowsPerPage = value
            this.rowsPerPage = value
        },
        createDashboard() {
            window.open(this.$router.resolve('/campaign/form').href)
        },
        updateQueryRoute(nameQuery, newVal, defaultVal) {
            let query = this.$utils.cloneObject(this.$route.query)
            if (newVal !== defaultVal) {
                query[nameQuery] = newVal
            } else {
                delete query[nameQuery]
            }
            this.$router.replace({
                query: query
            })
        },
        searchNow(keyword) {
            this.pagination.page = 1
            this.filter.search = keyword
            this.refreshSearch()
        },
        viewCampaignSearch(campaign) {
            this.$router.push('/campaign/' + campaign.id)
        },
        refreshSearch() {
            if (this.filter.search === '') {
                this.searchList = []
            } else {
                let pagination = this.$utils.cloneObject(this.pagination)
                pagination.rowsPerPage = pagination.totalItems
                this.$appService.showLoading()
                DashboardService.getOverviewData(
                    pagination,
                    this.$refs.TimeRangePicker.getTimestamp(),
                    this.callType
                ).then(result => {
                    this.searchList = result.data.data.filter(item => item["title"].toLowerCase().includes(this.filter.search.toLowerCase()))
                }).finally(this.$appService.hideLoading)
            }
        }
    },
    watch: {
        timeRange: function (newVal) {
            if (this.timeRange !== 'today') {
                this.autoRefreshInterval = 0
            }
            let query = this.$utils.cloneObject(this.$route.query)
            if (newVal.includes('➜')) {
                let fromTo = newVal.split('➜')
                let from = this.$utils.convertDateStringToTimestamp(fromTo[0].trim() + ':00')
                let to = this.$utils.convertDateStringToTimestamp(fromTo[1].trim() + ':59')
                query['time_range'] = `${from}to${to}`
            } else {
                if (newVal !== defaultFilter.timeRange) {
                    query['time_range'] = newVal
                } else {
                    delete query['time_range']
                }
            }
            this.$router.replace({
                query: query
            })
            this.updateDataCharts(query.interval)
        },
        callByTimeChart: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.StackBarChartCallByTime) {
                        this.$refs.StackBarChartCallByTime.render()
                    }
                })
            }
        },
        callDurationChart: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.StackBarChartCallDuration) {
                        this.$refs.StackBarChartCallDuration.render()
                    }
                })
            }
        },
        botResponseTimeChart: {
            deep: true,
            handler: function () {
                this.$nextTick(() => {
                    if (this.$refs.StackBarChartBotResponseTime) {
                        this.$refs.StackBarChartBotResponseTime.render()
                    }
                })
            }
        },
        'pagination.rowsPerPage': 'loadTableData',
        'pagination.page': 'loadTableData',
        'pagination.descending': 'loadTableData',
        '$route.query': {
            deep: true,
            immediate: true,
            handler: function (query) {
                // remove query params not accepted
                let paramQueries = Object.keys(query)
                let oldQuery = this.$utils.cloneObject(this.$route.query)
                let newQuery = this.$utils.cloneObject(this.$route.query)
                paramQueries.forEach(queryItem => {
                    if (!queriesAccept.includes(queryItem)) {
                        delete newQuery[queryItem]
                    }
                })
                if (!lodash.isEqual(oldQuery, newQuery)) {
                    this.$router.replace({
                        query: newQuery
                    })
                }
            }
        },
        filter: {
            deep: true,
            handler: function (newFilter) {
                let query = this.$utils.cloneObject(this.$route.query)
                query = {...query, ...newFilter}
                if (!query.status) {
                    delete query.status
                }
                if (!query.direction) {
                    delete query.direction
                }
                if (!query.search) {
                    delete query.search
                }
                this.$router.replace({
                    query: query
                })
            }
        }
    }
}
</script>
<style scoped lang="scss">
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.Dashboard {
    .select-custom {
        margin-right: 6px;
    }

    .title-chart {
        line-height: 30px;
        height: 30px;
        font-size: 16px;
        font-weight: 700;
    }

    ::v-deep {
        .v-menu {
            display: none !important;
        }

        .v-input__slot {
            padding: 0 10px !important;
            margin-bottom: 4px !important;
            border-radius: 5px !important;
            border: 1px solid #D9D9D9;
            font-size: 14px !important;
            height: 30px;
        }

        .v-input__slot:after {
            border: none !important;
        }

        .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
            border: none !important;
        }

        .v-input.v-text-field .v-label--active {
            background: #FFFFFF !important;
            top: 8px !important;
            left: -3px !important;
            padding: 0 4px;
            color: #617CA5 !important;
            font-size: 11px !important;
            z-index: 4;
        }
    }

    .overview-table {
        margin-top: 12px;
    }
}

.card-chart {
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    background: #FFFFFF;
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ::v-deep {
        .v-text-field {
            padding-top: 0 !important;
            margin-top: 0 !important;
        }

        .v-input__slot {
            margin-bottom: 0 !important;
        }
    }
}

::v-deep {
    .theme--light.v-list .v-list__tile--link:hover {
        background: #E6F4FF !important;
    }

    .container {
        padding: 0 !important
    }

    //.container.grid-list-lg .layout .flex {
    //    padding: 5px !important;
    //}

    .v-list__tile {
        font-size: 14px !important;
        height: 36px !important;
        border-top: 1px solid #E4EDFA;
        padding: 0 12px !important;
    }

    .v-list {
        padding: 0 !important;
        border-radius: 5px !important;
        overflow: hidden;
        margin-top: 28px;
        border: 1px solid #D9D9D9;
    }

    .v-list__tile--active {
        background: #E6F4FF !important;
    }
}

.btn-info-chart {
    position: absolute;
    top: 36px;
    right: 30px;


    &:hover ~ .info-chart {
        visibility: visible;
    }
}

.info-chart {
    position: absolute;
    top: 65px;
    right: 35px;
    border: 1px solid #e4edfa;
    background: #fff;
    font-size: 14px;
    padding: 12px;
    border-radius: 5px;
    visibility: hidden;
}

.additional-data {
    width: 100%;
    margin: 0;
    border-spacing: 0;


    tbody {
        td {
            font-size: 14px;
            padding: 12px;
        }

        td:last-child {
            text-align: right;
        }

        tr:nth-child(2n+2) td {
            background: #E4EDFA;
        }
    }
}
</style>
